"use strict";
export var Protocol = /* @__PURE__ */ ((Protocol2) => {
  Protocol2["V2"] = "V2";
  Protocol2["V3"] = "V3";
  Protocol2["V4"] = "V4";
  Protocol2["MIXED"] = "MIXED";
  return Protocol2;
})(Protocol || {});
